import * as React from "react";
import type { SVGProps } from "react";
const SvgHome03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={2}
      d="M2.4 9.244c0-.394.2-.764.538-.992l8.32-5.627c.444-.3 1.04-.3 1.484 0l8.32 5.627a1.2 1.2 0 0 1 .538.992v10.53c0 1.008-.86 1.826-1.92 1.826H4.32c-1.06 0-1.92-.818-1.92-1.826z"
    />
  </svg>
);
export default SvgHome03;
